module.exports = __webpack_public_path__ + "static/media/estandares-seguridad.6bc0c710.svg";